import type { ReportResponseDtoStatus } from '@api/WhisApi/generated';
import Chip from '@components/Chip/Chip';
import getStatusTextAndColor from '@components/ReportList/utils/getStatusTextAndColor';

interface StatusBadgeProps {
  status: ReportResponseDtoStatus;
}

export const StatusBadge = ({
  status,
}: StatusBadgeProps): React.ReactElement => {
  const { text, color } = getStatusTextAndColor(status);
  return <Chip text={text} color={color} />;
};
